import { Button } from "@/components/ui/baseUi/button"
import { Text } from "@/components/ui/baseUi/text"
import type { MediaItem } from "@/modules/common/media/mediaTypes"
import { cn } from "@/modules/lib/utils"
import type { SessionMediaItemEntity } from "@/modules/sessions/entities/sessionBlockMediaEntity"
import { PdfFileIcon } from "@images/svgIcons/medias/pdfFileIcon"
import { word } from "@modules/core/utils/i18n"
import { DownloadIcon } from "lucide-react"
import { Link } from "react-router"

type MediaDetailsPdfProps = {
  media: SessionMediaItemEntity | MediaItem
  className?: string
} & React.ComponentProps<"div">

export function MediaDetailsPdf({ media, className, ...props }: MediaDetailsPdfProps) {
  return (
    <div className={cn("relative flex flex-1 flex-col items-center justify-center gap-3", className)} {...props}>
      {media.url ? (
        <PdfFileIcon color="currentColor" className="text-textDefault-heading" />
      ) : (
        <Text fontStyle="BM" className="wrap-break-word">
          {word("sessionForm.blocks.add_media.missing_error")}
        </Text>
      )}
      <Text fontStyle="BM" className="wrap-break-word">
        {media.filename}
      </Text>

      <Link to={media.url} target="_blank">
        <Button variant="ghost" size="iconMd" className="absolute top-0 right-0 m-auto mt-3 mr-3">
          <DownloadIcon size={24} color="currentColor" className="text-textDefault-body" />
        </Button>
      </Link>
    </div>
  )
}
